import { ITreeNode } from "../../common/types/commonTypes";

export const getAllNodeValues = (nodes: ITreeNode[], selectAllChecked: boolean, isDisplayNameNeeded?: boolean) => {
  let result: string[] = [];

  function traverse(node) {
    const valueToPush = isDisplayNameNeeded ? {
      id: node.value || node.id,
      displayName: node.label || node.displayName,
    } : node.value || node.orgId || node.id
    result.push(valueToPush);
    if (selectAllChecked) {
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          traverse(child);
        }
      }
    }
  }

  for (const node of nodes) {
    traverse(node);
  }
  return result;
}
